(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/utils/dialogs.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/utils/dialogs.js');
"use strict";


const displayInfoDialog = isPnp => {
  const text = "\n    <p>\n    Logga in enkelt och s\xE4kert p\xE5 Svenska Spel Sport &amp; Casino med \n    BankID eller Freja eID. B\xE5da \xE4r elektroniska ID-handlingar som \xE4r j\xE4mf\xF6rbara med pass, \n    k\xF6rkort och andra fysiska legitimationer.\n    </p>\n    \n    <b>Saknar du e-legitimation?</b>\n    <p>\n    Best\xE4ll BankID hos din bank eller ladda ner Freja-appen gratis fr\xE5n Appstore, \n    Google Play eller AppGallery.\n    </p>\n    \n    <b>Beh\xF6ver du hj\xE4lp?</b>\n    <p>Ring oss p\xE5 0770 - 11 11 11</p>\n  ";
  const dialog = new svs.ui.dialog.Confirm({
    branding: isPnp ? svs.components.dialog.branding.MOMANG : svs.components.dialog.branding.SPORT,
    icon: 'help-2',
    title: 'Verifiera dig med BankID eller Freja eID',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.iam_idp.dialogs = {
  displayInfoDialog
};

 })(window);